var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12036_32239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.995 16C1.445 16 1 15.552 1 15L1 0.999999C1 0.447999 1.446 -1.09751e-06 1.995 -1.04951e-06L11.95 -1.79217e-07C12.0811 0.000262093 12.2108 0.0263356 12.3318 0.0767325C12.4528 0.127129 12.5626 0.200863 12.6551 0.293721C12.7476 0.386579 12.8209 0.496746 12.8708 0.617929C12.9207 0.739113 12.9463 0.86894 12.946 1L12.946 4L11.423 4L11.423 1.53L2.464 1.53L2.464 14.53L11.422 14.53L11.422 12L12.945 12L12.945 15C12.945 15.552 12.499 16 11.949 16L1.995 16ZM8.993 13.03L7.938 11.97L10.894 9L3.986 9L3.986 7L10.894 7L7.938 4.03L8.993 2.97L14 8L8.993 13.03Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12036_32239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.454f212421e3603fc58620b627c832c6.svg";
export { ForwardRef as ReactComponent };